<div
  class="popup-modal"
  [ngClass]="{ 'loader-overlay loading': isLoading$ | async }"
  [@openDynamicComponent]="modalConfiguration.animation"
  (@openDynamicComponent.start)="onAnimationStart($event)"
  (@openDynamicComponent.done)="onAnimationDone($event)">
  <ng-template #container [cdkPortalOutlet]></ng-template>
</div>
